module.exports = __webpack_public_path__ + "img/rule_zhCn.b9585383.png";